import React, { useState } from 'react'
import { motion } from 'framer-motion'
import MobileDrawer from './MobileDrawer'

const Navigation: React.FC = () => {
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false)

  const toggleMobileDrawer = () => {
    setIsMobileDrawerOpen(!isMobileDrawerOpen)
  }

  const closeMobileDrawer = () => {
    setIsMobileDrawerOpen(false)
  }

  return (
    <>
      <motion.nav
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="fixed top-0 left-0 right-0 bg-slate-900/90 backdrop-blur-sm border-b border-slate-700/50 z-50 w-full"
      >
        <div className="w-full px-4 py-3">
          <div className="flex items-center justify-between">
            {/* Mobile menu button */}
            <button
              onClick={toggleMobileDrawer}
              className="md:hidden text-bible-gold hover:text-yellow-300 text-xl p-2 rounded transition-colors"
              title="Open Menu"
            >
              ☰
            </button>

            {/* Left side - Navigation links (desktop) */}
            <div className="hidden md:flex items-center gap-4">
              <a 
                href="/" 
                className="text-bible-gold hover:text-yellow-300 transition-colors duration-200 flex items-center gap-2 text-sm font-medium"
                title="Back to Home"
              >
                🏠 Home
              </a>
              <a 
                href="/slideshow-generator" 
                className="text-bible-gold hover:text-yellow-300 transition-colors duration-200 flex items-center gap-2 text-sm font-medium"
                title="Slideshow Generator"
              >
                ✨ Slideshow Generator
              </a>
              <a 
                href="/bible-studies/daniel/chapter7" 
                className="text-bible-gold hover:text-yellow-300 transition-colors duration-200 flex items-center gap-2 text-sm font-medium"
                title="Daniel Chapter 7"
              >
                📖 Daniel 7
              </a>
            </div>

            {/* Right side - Study info */}
            <div className="hidden md:flex items-center gap-2 text-xs text-gray-400">
              <span>Interactive Study</span>
              <span>•</span>
              <span>ESV Bible</span>
            </div>
          </div>
        </div>
      </motion.nav>

      {/* Mobile Drawer */}
      <MobileDrawer isOpen={isMobileDrawerOpen} onClose={closeMobileDrawer} />
    </>
  )
}

export default Navigation
